import cathayVueLoader from "../../../components/common/cathay-message/loader";

export default {
  install(Vue, options = {}) {
    //loader
    const VueLoader = Vue.extend(cathayVueLoader);
    const Loader = new VueLoader();
    const vmLoader = Loader.$mount();
    document.querySelector("body").appendChild(vmLoader.$el);

    Vue.prototype.$loader = (loading, spinnerStyle = {}) => {
      Loader.setClass(loading, spinnerStyle);
    };

    Vue.prototype.$loader.open = (spinnerStyle = {}) => {
      Loader.setClass(true, spinnerStyle);
    };

    Vue.prototype.$loader.close = (spinnerStyle = {}) => {
      Loader.setClass(false, spinnerStyle);
    };

    Vue.$loader = Vue.prototype.$loader;
  }
};
